import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstChar',
})
export class FirstCharPipe implements PipeTransform {
  transform(value = '') {
    if (!value) {
      return '';
    }
    return value.split('')[0];
  }
}
